import React, { useCallback, useState } from 'react';
import * as Icon from 'react-feather';
import { Button } from 'antd';
import { UserBookmarkModal } from '../../dashboard/settings/userBookmarks/UserBookmarkModal';
import { Tooltip } from './Tooltip';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './BookmarkCreate.translations.json';

const { addTranslations, t } = i18nNsFactory('bookmark-create');
addTranslations(translations);

export interface BookmarkCreateProps {
  excludeUrlParams?: Array<String>;
  includeUrlParams?: Array<{ key: string; value: string }>;
}
export const BookmarkCreate = (props: BookmarkCreateProps) => {
  const { excludeUrlParams, includeUrlParams } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <Tooltip title={t('tooltip')}>
        <Button
          id="bookmark-create"
          onClick={showModal}
          icon={<Icon.Bookmark size={20} />}
        />
      </Tooltip>
      {isModalOpen && (
        <UserBookmarkModal
          mode="create"
          excludeUrlParams={excludeUrlParams}
          includeUrlParams={includeUrlParams}
          onClose={handleClose}
          onSuccess={handleClose}
        />
      )}
    </>
  );
};
